{
  "channels": [
    "description",
    "high_cutoff",
    "low_cutoff",
    "name",
    "notch",
    "source",
    "detector",
    "wavelength_actual",
    "wavelength_nominal",
    "wavelength_emission_actual",
    "component",
    "short_channel",
    "sampling_frequency",
    "software_filters",
    "status",
    "status_description",
    "type",
    "units",
    "reference",
    "group",
    "tracking_system",
    "tracked_point",
    "component",
    "placement",
    "HED"
  ],
  "electrodes": [
    "name",
    "x",
    "y",
    "z",
    "size",
    "material",
    "manufacturer",
    "group",
    "hemisphere",
    "type",
    "impedance",
    "dimension",
    "HED"
  ],
  "optodes": [
    "name",
    "type",
    "x",
    "y",
    "z",
    "template_x",
    "template_y",
    "template_z",
    "source_type",
    "detector_type",
    "HED"
  ],
  "events": [
    "duration",
    "HED",
    "onset",
    "trial_type",
    "response_time",
    "stim_file",
    "HED"
  ],
  "misc": [],
  "participants": ["participant_id", "HED"],
  "phenotype": ["participant_id", "HED"],
  "scans": ["acq_time", "filename", "HED"],
  "samples": [
    "sample_id",
    "participant_id",
    "sample_type",
    "pathology",
    "derived_from",
    "HED"
  ],
  "sessions": ["acq_time", "session_id", "HED"],
  "aslcontext": ["volume_type", "HED"],
  "blood": [
    "time",
    "plasma_radioactivity",
    "whole_blood_radioactivity",
    "metabolite_parent_fraction",
    "hplc_recovery_fractions",
    "HED"
  ],
  "nirs": [
    "name",
    "type",
    "source",
    "detector",
    "wavelength_nominal",
    "units",
    "sampling_frequency",
    "component",
    "wavelength_actual",
    "description",
    "wavelength_emission_actual",
    "short_channel",
    "status",
    "status_description",
    "HED"
  ]
}
